import {GetChunkFn} from '../types/GetChunkFn';
import {QueueVideoTask} from '../types/QueueVideoTask';
import {QueueVideoTaskJob} from '../types/QueueVideoTaskJob';

export function getFileChunk(
  task: QueueVideoTask,
  job: QueueVideoTaskJob,
  getChunk: GetChunkFn
): Promise<ArrayBuffer> {
  const index = job.partNumber - 1; // partNumber starts from 1
  return getChunk({index, fileSize: task.size, chunkSize: task.chunkSize, uri: task.uri});
}
